export default __webpack_public_path__ + "static/media/nsut-logo-1800x1800.3252a3a9.png";